import React, { Component } from 'react';

class VenueSliderSkeleton extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="slider-skeleton px-2 px-lg-0">
        {
          Array.from(Array(3).keys()).map((i) => {
            return (
              <div className="slide px-3" key={i}>
                <div className="slide-wrapper skeleton-shine" />
              </div>
            );
          })
        }
      </div>
    );
  }
}

export default VenueSliderSkeleton;



// WEBPACK FOOTER //
// ./scripts/components/VenueSliderSkeleton/VenueSliderSkeleton.js